/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Filter_Any_TypeInputs */

const cs_public_site_filter_any_type = /** @type {(inputs: Public_Site_Filter_Any_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Všechny typy`)
};

const en_public_site_filter_any_type = /** @type {(inputs: Public_Site_Filter_Any_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All types`)
};

/**
* | output |
* | --- |
* | "All types" |
*
* @param {Public_Site_Filter_Any_TypeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_filter_any_type = /** @type {((inputs?: Public_Site_Filter_Any_TypeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Filter_Any_TypeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_filter_any_type(inputs)
	return cs_public_site_filter_any_type(inputs)
});